import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';

import React, { useState, useEffect, useRef, useContext } from 'react';

/* ################ IMPORTS OF PRIMEREACT ################*/
import { DataTable } from 'primereact/datatable';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';


import { Link } from "react-router-dom";

import '../../css/listInstances.css';

import InstancesIntegration from '../../integrations/InstancesIntegration';
import { EnvContext } from '../Context/EnvProvider';
import { useAuthToken } from '../../hooks/useAuthToken';
import useQuery from '../../hooks/useQuery';

const instancesIntegration = new InstancesIntegration();

const ListInstances = () => {

    const [instances, setInstances] = useState([]);
    const [language, setLanguage] = useState([]);
    const [instanceDialog, setInstanceDialog] = useState(false);
    const [instance, setInstance] = useState([]);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [loading, setLoading] = useState(true);
    const query = useQuery();
    const toast = useRef(null);
    const dt = useRef(null);
    const { getAccessToken } = useAuthToken();

    const { environment } = useContext(EnvContext);

    const [reload, setReload] = useState(false);

    let templateId = query.get("templateId");
    useEffect(() => {
        const loadData = async () => {
            try {
                const authToken = await getAccessToken();

                const data = await instancesIntegration.listInstances(environment.botApi, templateId, authToken);
                setInstances(data);
                setReload(false);
                setLoading(false);

                const languageData = await instancesIntegration.getLanguage();
                let localLanguage = [];
                for (let i = 0, l = languageData.length; i < l; i += 1) {
                    localLanguage[i] = languageData[i].name;
                }
                setLanguage(localLanguage);
            } catch (error) {
                console.error(error);
                setLoading(false);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Erro!',
                    detail: 'Erro ao carregar instâncias.',
                    life: 5000,
                });
            }
        };
        
        loadData();
    }, [environment.botApi, getAccessToken, reload, templateId]);

    const showResponseMessage = (json) => {
        if (json.status !== 400) {
            toast.current.show({ severity: 'success', summary: 'Sucesso!', detail: "Instancia Salvo com Sucesso", life: 5000 });
        }
        else {
            toast.current.show({ severity: 'error', summary: 'Erro!', detail: json.error, life: 5000 });
        }

    }

    const saveInstance = async () => {
        setInstanceDialog(false);
        try {
            const authToken = await getAccessToken();
            
            let templateInstance = {
                ...instance
            }
            const json = await instancesIntegration.saveInstance(environment.botApi, templateInstance, templateId, authToken);
            showResponseMessage(json);
            setReload(true);
        } catch (error) {
            console.error(error);
            toast.current.show({ severity: 'error', summary: 'Erro!', detail: 'Erro ao salvar a instancia.', life: 5000 });
        }
    }

    const openNew = () => {
        setInstance(instancesIntegration.createEmptyInstance());
        setInstanceDialog(true);
    }
    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _instance = { ...instance };
        _instance[`${name}`] = val;

        setInstance(_instance);
    }

    const editInstance = (instance) => {
        setInstance({ ...instance });
        setInstanceDialog(true);
    }

    const hideDialog = () => {
        setInstanceDialog(false);
    }

    const leftToolbarInstance = () => {
        return (
            <React.Fragment>
                <Button label="Novo" icon="pi pi-plus" className="p-button-success p-mr-2" onClick={openNew} />
            </React.Fragment>
        )
    }

    const actionBodyInstance = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-mr-2" onClick={() => editInstance(rowData)} />
            </React.Fragment>
        );
    }

    const header = (
        <div className="table-header">
            <h5 className="p-mx-0 p-my-1">Procurar Instancias</h5>
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Procurar..." />
            </span>
        </div>
    );
    const instanceDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Salvar" icon="pi pi-check" className="p-button-text" onClick={saveInstance} />
        </React.Fragment>
    );

    return (
        <div className="listInstances">
            <Toast ref={toast} />

            <div className="card">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li className="breadcrumb-item">
                            <Link to="/ListBotTemplates">Lista de Templates</Link>
                        </li>
                        <li className="breadcrumb-item active">
                            <span>Configuração de instancias</span>
                        </li>
                    </ol>
                </nav>
            </div>

            <div className="card">
                <Toolbar className="p-mb-4" left={leftToolbarInstance}></Toolbar>

                <DataTable ref={dt} value={instances}
                    dataKey="id"
                    globalFilter={globalFilter} header={header} responsiveLayout="scroll"
                    loading={loading}>
                    <Column field="instanceTitle" header="Nome da Instância" style={{ minWidth: '12rem' }}></Column>
                    <Column field="dialogflowProject" header="DialogFlow Project" style={{ minWidth: '16rem' }}></Column>
                    <Column field="currentAvailableBotSlots" header="Qnt Bots Disponiveis" style={{ minWidth: '12rem' }}></Column>
                    <Column field="currentNumberOfBots" header="Qnt Bots Existentes" style={{ minWidth: '16rem' }}></Column>
                    <Column body={actionBodyInstance} exportable={false} style={{ minWidth: '8rem' }}></Column>
                </DataTable>
            </div>

            <Dialog visible={instanceDialog} style={{ width: '800px' }} header="Edição de Instancias" modal className="p-fluid" footer={instanceDialogFooter} onHide={hideDialog}>
                <div className="p-fluid p-grid">
                    <div className="p-field p-col-12 p-md-12">
                        <h3>Servidor</h3>
                    </div>
                    <div className="p-field p-col-12 p-md-12">
                        <label htmlFor="instanceTitle">Título da Instância</label>
                        <InputText id="instanceTitle" value={instance.instanceTitle} onChange={(e) => onInputChange(e, 'instanceTitle')} required autoFocus />
                    </div>
                    <div className="p-field p-col-12 p-md-6">
                        <label htmlFor="botType">Tipo do bot</label>
                        <InputText id="botType" value={instance.botType} onChange={(e) => onInputChange(e, 'botType')} required />
                    </div>
                    <div className="p-field p-col-12 p-md-6">
                        <label htmlFor="agenda">AgendaApi</label>
                        <InputText id="agenda" value={instance.agendaAPI} onChange={(e) => onInputChange(e, 'agendaAPI')} required />
                    </div>
                    <div className="p-field p-col-12 p-md-6">
                        <label htmlFor="conversationAPI">ConversationAPI</label>
                        <InputText id="conversationAPI" value={instance.conversationAPI} onChange={(e) => onInputChange(e, 'conversationAPI')} required />
                    </div>
                    <div className="p-field p-col-12 p-md-6">
                        <label htmlFor="conversationAPIVersion">ConversationAPI version</label>
                        <InputText id="conversationAPIVersion" value={instance.conversationAPIVersion} onChange={(e) => onInputChange(e, 'conversationAPIVersion')} required />
                    </div>
                    <div className="p-field p-col-12 p-md-6">
                        <label htmlFor="whatsappBaseIntegration">Whatsapp API base integration</label>
                        <InputText id="whatsappBaseIntegration" value={instance.whatsappBaseIntegration} onChange={(e) => onInputChange(e, 'whatsappBaseIntegration')} required />
                    </div>
                    <div className="p-field p-col-12 p-md-6">
                        <label htmlFor="rateLimiterConversation">Máximo de chamadas por segundo</label>
                        <InputNumber inputId="rateLimiterConversation" value={instance.rateLimiterConversation} mode="decimal" useGrouping={false} onValueChange={(e) => onInputChange(e, 'rateLimiterConversation')} required />
                    </div>
                    <div className="p-field p-col-12 p-md-6">
                        <label htmlFor="currentAvailableBotSlots">Número de bots disponíveis</label>
                        <InputNumber inputId="currentAvailableBotSlots" value={instance.currentAvailableBotSlots} mode="decimal" useGrouping={false} onValueChange={(e) => onInputChange(e, 'currentAvailableBotSlots')} required />
                    </div>
                    <div className="p-field p-col-12 p-md-6">
                        <label htmlFor="currentNumberOfBots">Número atual de bots</label>
                        <InputNumber inputId="currentNumberOfBots" value={instance.currentNumberOfBots} mode="decimal" useGrouping={false} onValueChange={(e) => onInputChange(e, 'currentNumberOfBots')} required />
                    </div>
                    <div className="p-field p-col-12 p-md-12">
                        <h3>NLU</h3>
                    </div>
                    <div className="p-field p-col-12 p-md-6">
                        <label htmlFor="dialogflowProject">Nome do Projeto Dialogflow</label>
                        <InputText id="dialogflowProject" value={instance.dialogflowProject} onChange={(e) => onInputChange(e, 'dialogflowProject')} required />
                    </div>
                    <div className="p-field p-col-12 p-md-6">
                        <label htmlFor="dialogflowCredentialsURL">URL Credenciais do Dialogflow</label>
                        <InputText id="dialogflowCredentialsURL" value={instance.dialogflowCredentialsURL} onChange={(e) => onInputChange(e, 'dialogflowCredentialsURL')} required />
                    </div>
                    <div className="p-field p-col-12 p-md-6">
                        <label htmlFor="dialogflowEnvironment">Dialogflow Environment</label>
                        <InputText id="dialogflowEnvironment" value={instance.dialogflowEnvironment} onChange={(e) => onInputChange(e, 'dialogflowEnvironment')} required />
                    </div>
                    <div className="p-field p-col-12 p-md-6">
                        <label htmlFor="dialogflowUsername">Nome do usuário Dialogflow</label>
                        <InputText id="dialogflowUsername" value={instance.dialogflowUsername} onChange={(e) => onInputChange(e, 'dialogflowUsername')} required />
                    </div>
                    <div className="p-field p-col-12 p-md-12">
                        <span className="p-float-label">
                            <Dropdown
                                value={instance.dialogFlowLanguage}
                                options={language}
                                onChange={(e) => onInputChange(e, 'dialogFlowLanguage')}
                                placeholder="Selecione o Idioma do Dialogflow"
                            >
                            </Dropdown >
                        </span>
                    </div>

                </div>
            </Dialog>
        </div>
    );
}
export default ListInstances;
